import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import { categoryCollection } from 'app/src/msw/companyagreement/initialSeed/categories'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

/**
 * Handles GET requests to the `/categories` endpoint by retrieving categories from the `categoryCollection`
 * @returns A paginated list of categories that match the query parameters, or an empty list if no such categories exist
 */
export const getCategories = http.get<object, DefaultBodyType, companyagreementApi.CategoryPaginated>(
  apiBaseUrl + '/categories',
  async ({ request }) => {
    // set of request parameters
    const url = new URL(request.url)
    const limit: number = Number.parseInt(url.searchParams.get('pagingLimit') ?? '10')
    const offset: number = Number.parseInt(url.searchParams.get('pagingOffset') ?? '0')
    const serviceCategory = url.searchParams.get('serviceCategory') ?? ''
    const parentCategoryId = url.searchParams.get('parentCategoryId') ?? ''

    console.log('Received request for getCategories with params:', {
      limit,
      offset,
      serviceCategory,
      parentCategoryId,
    })

    // empty response
    const emptyResponse: companyagreementApi.CategoryPaginated = { paging: { limit, offset, total: 0 }, items: [] }

    /**
     * Converts an array of categories into a paginated response.
     * @param categories The array of categories to paginate.
     * @returns A paginated response containing the categories.
     */
    const convertToPaginatedResponse = (categories: companyagreementApi.Category[]): companyagreementApi.CategoryPaginated => ({
      paging: { limit, offset, total: categories.length },
      items: categories.slice(offset, offset + limit),
    })

    // selected products variable
    let selectedCategoryCollection = []

    // where clause to filter products based on the provided query parameters
    const where: {
      parentCategoryId?: string
      serviceCategory?: 'welfareArt100' | 'welfareArt51' | 'none'
    } = {}

    // if serviceCategory is provided, add it to the where clause
    if (serviceCategory) {
      where.serviceCategory = serviceCategory as 'welfareArt100' | 'welfareArt51' | 'none'
    }

    // if parentCategoryId is provided, add it to the where clause
    if (parentCategoryId) {
      where.parentCategoryId = parentCategoryId
    }

    // query the collection with the where clause
    selectedCategoryCollection = categoryCollection.findMany((q) => q.where(where))

    // if no categories are found, return an empty response
    if (!selectedCategoryCollection.length) {
      return HttpResponse.json(emptyResponse)
    } else {
      const response = convertToPaginatedResponse(selectedCategoryCollection)
      return HttpResponse.json(response)
    }
  },
)
